import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface LifestylesKeyType {
  creationImportFailed: LocalesKey;
  creationImportMultipleMaxFiles: LocalesKey;
  addLifestyle: LocalesKey;
  addCompanyLifestyle: LocalesKey;
  all: LocalesKey;
  associatedAssets: LocalesKey;
  associatedLifestyles: LocalesKey;
  associatedProducts: LocalesKey;
  associatedMaterials: LocalesKey;
  associatedScenes: LocalesKey;
  attach: LocalesKey;
  attachLifestyle: LocalesKey;
  attachSelected: LocalesKey;
  categories: {
    bedroom: LocalesKey;
    commercialAreas: LocalesKey;
    dining: LocalesKey;
    exteriors: LocalesKey;
    livingApartments: LocalesKey;
    sanitaryFacilities: LocalesKey;
    transitAreas: LocalesKey;
  };
  category: LocalesKey;
  clearLifestyleCache: LocalesKey;
  clearLifestylesCache: LocalesKey;
  companyLifestyle: LocalesKey;
  deleteLifestyle: LocalesKey;
  deleteWarning: LocalesKey;
  download: LocalesKey;
  editLifestyle: LocalesKey;
  my: LocalesKey;
  name: LocalesKey;
  plural: LocalesKey;
  projectName: LocalesKey;
  search: LocalesKey;
  selected: LocalesKey;
  singular: LocalesKey;
  threeDStock: LocalesKey;
  timeHours: LocalesKey;
  type: LocalesKey;
  viewAll: LocalesKey;
  uploadToLibrary: LocalesKey;
}

export const lifestylesKeys = keyPathMirror<LifestylesKeyType, string>(
  {
    creationImportFailed: null,
    creationImportMultipleMaxFiles: null,
    addLifestyle: null,
    addCompanyLifestyle: null,
    all: null,
    associatedAssets: null,
    associatedLifestyles: null,
    associatedProducts: null,
    associatedMaterials: null,
    associatedScenes: null,
    attach: null,
    attachLifestyle: null,
    attachSelected: null,
    categories: {
      bedroom: null,
      commercialAreas: null,
      dining: null,
      exteriors: null,
      livingApartments: null,
      sanitaryFacilities: null,
      transitAreas: null
    },
    category: null,
    clearLifestyleCache: null,
    clearLifestylesCache: null,
    companyLifestyle: null,
    deleteLifestyle: null,
    deleteWarning: null,
    download: null,
    editLifestyle: null,
    my: null,
    name: null,
    plural: null,
    projectName: null,
    search: null,
    selected: null,
    singular: null,
    threeDStock: null,
    timeHours: null,
    type: null,
    viewAll: null,
    uploadToLibrary: null
  },
  'models.lifestyles.'
);
